const MONTHS = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
];

export const fmtDate = (d: Date | string | number): string => {
  const x = d instanceof Date ? d : new Date(d);
  return x.toLocaleDateString('de-AT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const fmtDateTime = (d: Date | string | number): string => {
  const x = d instanceof Date ? d : new Date(d);
  return `${fmtDate(x)} ${x.toLocaleTimeString('de-AT', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};

export interface VideoEmbed {
  kind: 'iframe' | 'file';
  src: string;
}

export const toVideoEmbed = (url: string): VideoEmbed => {
  const youtube = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]+)/,
  );
  if (youtube) {
    return {
      kind: 'iframe',
      src: `https://www.youtube.com/embed/${youtube[1]}`,
    };
  }

  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) {
    return {
      kind: 'iframe',
      src: `https://player.vimeo.com/video/${vimeo[1]}`,
    };
  }

  return { kind: 'file', src: url };
};

export interface DayLabel {
  big: string;
  small: string;
  key: string;
  sortKey: number;
}

export const dayLabel = (d: Date | string | number): DayLabel => {
  const x = d instanceof Date ? d : new Date(d);
  const day0 = new Date(x.getFullYear(), x.getMonth(), x.getDate());
  return {
    big: `${x.getDate()}. ${MONTHS[x.getMonth()]}`,
    small: String(x.getFullYear()),
    key: `${day0.getFullYear()}-${String(day0.getMonth() + 1).padStart(2, '0')}-${String(
      day0.getDate(),
    ).padStart(2, '0')}`,
    sortKey: day0.getTime(),
  };
};
